import { Injectable } from '@angular/core';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';

export interface SubmitAppResponse {
  appTrackingId: string
}
@Injectable({
  providedIn: 'root'
})

export class EnrollmentSubmissionService {

  constructor(
    private httpClient: HTTPWrapperContext
  ) { }

  async submitApplication(payload: any, isSecureService: boolean): Promise<SubmitAppResponse | HttpErrorResponse> {
    const secureUrl = '/sxesvc/api/v3/sec/submitApp';
    const nonSecureUrl = '/sxesvc/api/v1/submitApp';

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: isSecureService ? secureUrl : nonSecureUrl,
      headers: new HttpHeaders({
      }),
      POST_OR_PUT_PAYLOAD: payload
    });

    if (isSecureService) {
      this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    } else {
      this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_PRE_PASS);
    }

    const response: SubmitAppResponse | HttpErrorResponse
    = await this.httpClient
    .makeRequest<{ appTrackingId: string }>(requestConfig)
    .catch( (error: HttpErrorResponse) => {
      return error;
    });

    return response;
  }
  
}

